import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

//(before rendering the app)
window.addEventListener("error", (event) => {
  console.error("Global JS Error:", event.error);
});

window.addEventListener("unhandledrejection", (event) => {
  console.error("Unhandled Promise Rejection:", event.reason);
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
